// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eNcL","top":"styles_top__3WvYR","left":"styles_left__1R1Hg","description":"styles_description__VoLNA"};